import { useContext } from "react";
import {
  ProjectListContext,
  type ProjectListContextValue,
} from "../providers/ProjectListProvider";

export const useProjectListContext = (): ProjectListContextValue => {
  const context = useContext(ProjectListContext);

  if (!context) {
    throw new Error(
      "useProjectListContext must be used within a ProjectListProvider",
    );
  }

  return context;
};
